export default __webpack_public_path__ + "static/media/vue.91541bbe.png";